import React, { ReactElement } from 'react';
import { chunk } from 'lodash-es';
import { css } from '@emotion/css';

type ReportGridTableProps = {
  content: string[];
  header?: string;
  numberOfColumns?: number;
};

/*
 * Shows a list of information in a table format to use less space
 * Uses four columns if each item is a short string, or two columns if there are any longer strings
 */
export default function ReportGridTable(props: ReportGridTableProps): ReactElement {
  const { content, header } = props;

  const suggestedNumberOfColumns =
    props.numberOfColumns ?? (content.some(str => str && str.length > 20) ? 2 : 4);
  const numberOfColumns = Math.min(suggestedNumberOfColumns, content.length);
  const rows = chunk(content, numberOfColumns).map(row => {
    // Make sure all rows are filled
    while (row.length < numberOfColumns) row.push('');
    return row;
  });

  return (
    <table
      className="compact"
      style={{ tableLayout: 'fixed', width: '100%', wordBreak: 'break-all' }}
    >
      {header && (
        <thead>
          <tr>
            <th colSpan={numberOfColumns}>{header}</th>
          </tr>
        </thead>
      )}
      <tbody
        // Force even column widths
        className={css`
          td {
            width: ${100 / numberOfColumns}%;
          }
        `}
      >
        {rows.map((row, i) => (
          <tr key={i}>
            {row.map((val, j) => (
              <td key={`${i}-${j}`}>{val}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
